// src/utils/previewMode.ts
// 🟡 CHECK-IN PREVIEW MODE (v6.460)
// ΠΡΙΝ την ημέρα check-in (σήμερα < start_date, ώρα Αθήνας) ο πελάτης κάνει ΚΑΝΟΝΙΚΑ
// όλη τη ροή check-in (σελίδες 1-3) ως ΔΟΚΙΜΗ, αλλά ΤΙΠΟΤΑ δεν γράφεται:
//   - savePage1/2/3DataHybrid → no-op
//   - savePageMedia (localStorage draft) → no-op
//   - box-consents.php POST (DynamicBox) → no-op
// Από την ημέρα check-in και μετά (σήμερα >= start_date) → κανονική λειτουργία.
//
// ΔΕΝ αφορά: check-out (mode='out'), Charter Agreement, σελίδες 4-5.

import { getCharterWindow } from './charterWindow';

// Module-level flag — το θέτουν οι σελίδες 1/2/3 μόλις ξέρουν ημερομηνίες + mode.
let _previewOn = false;

/** True όσο τρέχει check-in preview (δεν αποθηκεύεται τίποτα). */
export function isCheckinPreview(): boolean {
  return _previewOn;
}

export function setCheckinPreview(on: boolean): void {
  if (_previewOn !== on) {
    console.log(on ? '🟡 CHECK-IN PREVIEW ON — δεν αποθηκεύεται τίποτα' : '🟢 CHECK-IN PREVIEW OFF — κανονική αποθήκευση');
  }
  _previewOn = on;
}

/**
 * Preview ΜΟΝΟ όταν: mode='in' ΚΑΙ σήμερα < ημέρα check-in (isBeforeCheckIn).
 * Χωρίς checkInDate → false (fail-safe: κανονική αποθήκευση).
 */
export function computeCheckinPreview(checkInDate: any, checkOutDate: any, mode: any): boolean {
  if (!checkInDate) return false;
  if (mode === 'out') return false;
  return !!getCharterWindow(checkInDate, checkOutDate).isBeforeCheckIn;
}

/** Υπολογίζει ΚΑΙ θέτει το flag. Επιστρέφει το αποτέλεσμα για badge rendering. */
export function syncCheckinPreview(checkInDate: any, checkOutDate: any, mode: any): boolean {
  const on = computeCheckinPreview(checkInDate, checkOutDate, mode);
  setCheckinPreview(on);
  return on;
}
